module.exports = __webpack_public_path__ + "static/media/flamesax.b9a7ec0a.jpg";